import { isAfter } from 'date-fns';

import { IHome } from '@/modules/home/types';

export const sortFieldsByStatus = (fields: IHome.IField[]) => {
  const sortOrder = { active: 0, completed: 1, inactive: 2 };
  return fields.sort((a: IHome.IField, b: IHome.IField) => {
    // First, compare statuses
    const statusComparison = sortOrder[a.status] - sortOrder[b.status];
    // if not same status
    if (statusComparison !== 0) {
      return statusComparison;
    }
    // If statuses are the same, compare planned flag
    if (a.planned && !b.planned) {
      return -1; // a has planned flag, should come first
    } else if (!a.planned && b.planned) {
      return 1; // b has planned flag, should come first
    }
    return 0; // Both have same status and planned flag, maintain order
  });
};

export const filteredFieldsByArchived = (
  fields: IHome.IField[],
  date: Date
): IHome.IField[] => {
  return fields.filter(
    (field) =>
      field.fieldStatus === 'ACTIVE' ||
      (field.fieldStatus === 'INACTIVE' &&
        isAfter(new Date(field?.updatedAt), date)) ||
      (field.fieldStatus === 'INACTIVE' &&
        isTheSameDay(date, new Date(field?.updatedAt)))
  );
};

export const isTheSameDay = (d1: Date, d2: Date) => {
  return (
    d1.getFullYear() === d2.getFullYear() &&
    d1.getMonth() === d2.getMonth() &&
    d1.getDay() === d2.getDay()
  );
};

export const getFieldStatusCounts = (fields: IHome.IField[]) => {
  const counts = {
    active: 0,
    inactive: 0,
    completed: 0,
  };
  fields.forEach((field) => {
    counts[field.status]++;
  });
  return counts;
};
